import { render, staticRenderFns } from "./WebReviewView.vue?vue&type=template&id=defe7e84&"
import script from "./WebReviewView.vue?vue&type=script&lang=js&"
export * from "./WebReviewView.vue?vue&type=script&lang=js&"
import style0 from "./WebReviewView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports